module.exports = __webpack_public_path__ + "img/2-min.4d7ff52f.jpg";